// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__2nu3i","sidebar":"layout_sidebar__5s__Q","default":"layout_default__3xUm2"};